/* global Kameleoon, kameleoonQueue */

import LocalStorageCache from 'core/utils/cache/localStorage';

const localStorageCache = new LocalStorageCache();

const checkIsKameleoonAvailable = () => {
  const isEnabled = window.initialState.app.features.kameleoon?.isEnabled;
  return isEnabled && window.kameleoonQueue;
};

/* Product events */
export const trackKameleoonInterstitialButtonClickEvent = () => {
  if (!checkIsKameleoonAvailable()) return;

  try {
    kameleoonQueue.push(() => {
      Kameleoon.API.Goals.processConversion('click_button');
    });
  } catch (error) {
    console.error(error);
  }
};

export const trackKameleoonInterstitialMallClickEvent = () => {
  if (!checkIsKameleoonAvailable()) return;

  try {
    kameleoonQueue.push(() => {
      Kameleoon.API.Goals.processConversion('click_mall');
    });
  } catch (error) {
    console.error(error);
  }
};

/* Visit events */
export const trackKameleoonLoginEvent = () => {
  if (!checkIsKameleoonAvailable()) return;

  try {
    const IS_KAMELEOON_LOGIN_EVENT_SENT_KEY = 'isKameleoonLoginEventSent';
    const isKameleoonLoginEventSent = localStorageCache.getItem(IS_KAMELEOON_LOGIN_EVENT_SENT_KEY);
    const { user: { isIdentified } } = window.initialState;

    if (isIdentified && !isKameleoonLoginEventSent) {
      kameleoonQueue.push(() => {
        Kameleoon.API.Data.setCustomData('recipient_id', window.personalizationVendorCuid);
      });
      localStorageCache.setItem(IS_KAMELEOON_LOGIN_EVENT_SENT_KEY, true);
    }
  } catch (error) {
    console.error(error);
  }
};
